import React from "react";
import { Button } from "antd";
import { Plus } from "lucide-react";

const GRADIENT = "linear-gradient(135deg, #6366f1, #4f46e5)";

/**
 * Shared primary call-to-action button so every page-level create/action
 * button (Pair New Screen, New Playlist, Create Campaign, Create Event, …)
 * stays visually identical. Pass `icon={null}` to omit the leading icon, or
 * `icon={<SomeIcon size={15} />}` to override the default plus icon.
 */
const PrimaryActionButton = ({
  children,
  icon,
  onClick,
  disabled = false,
  style = {},
  ...rest
}) => {
  const leadingIcon = icon === undefined ? <Plus size={15} /> : icon;

  return (
    <Button
      type="primary"
      onClick={onClick}
      disabled={disabled}
      style={{
        borderRadius: 10,
        height: 40,
        fontWeight: 700,
        fontSize: 14,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        paddingInline: 16,
        ...(disabled
          ? {}
          : {
              background: GRADIENT,
              borderColor: "#4f46e5",
              boxShadow: "0 8px 18px rgba(99, 102, 241, 0.18)",
            }),
        ...style,
      }}
      {...rest}
    >
      {leadingIcon}
      {children != null && <span>{children}</span>}
    </Button>
  );
};

export default PrimaryActionButton;
